import React from "react";

import {
  isValidIconName,
  useIsMobile,
  WSAvatar,
  WSElement,
  WSFlexBox,
  WSIcon,
  WSIconName,
  WSImage,
  WSPanel,
  WSText
} from "@wingspanhq/fe-component-library";
import { ISubscription } from "@wingspanhq/users";
import { useHistory } from "react-router-dom";
import { getCostOfBenefitWithSubscription } from "../utils";
import { ExtendedWebflowBenefit } from "../types";

interface BenefitsCMSBlockProps {
  benefit: ExtendedWebflowBenefit;
  subscription?: ISubscription;
  pagePath: string;
}

export const BenefitsCMSBlock: React.FC<BenefitsCMSBlockProps> = ({
  benefit,
  subscription,
  pagePath
}) => {
  const isMobile = useIsMobile();
  const history = useHistory();

  const {
    atAGlance,
    logo,
    icon: iconString,
    helperCostDescription,
    iconBackgroundColor = "blue50",
    iconColor = "blue500",
    name,
    slug
  } = benefit;

  let icon: WSIconName = "heart";
  if (!logo?.src && iconString) {
    if (isValidIconName(iconString)) {
      icon = iconString;
    }
  }

  return (
    <WSPanel
      key={slug}
      data-testid={`block-${slug}`}
      onClick={() => history.push(pagePath, { comingFromBenefitsPage: true })}
      mt="L"
      p="L"
    >
      <WSFlexBox
        direction={isMobile ? "column" : "row"}
        alignContent={isMobile ? "flex-start" : "center"}
        alignItems={isMobile ? "flex-start" : "center"}
        wrap="nowrap"
        gap="M"
      >
        <WSFlexBox.CenterY wrap="nowrap" style={{ flexBasis: "75%" }} pr="2XL">
          {logo ? (
            <WSImage
              placeholder={
                <WSAvatar.Icon
                  icon={icon}
                  size="L"
                  color={iconColor}
                  colorBackground={iconBackgroundColor}
                />
              }
              mr="XL"
              src={logo.src}
              width={48}
            />
          ) : (
            <WSAvatar.Icon
              icon={icon}
              size="L"
              color={iconColor}
              colorBackground={iconBackgroundColor}
              mr="XL"
            />
          )}
          <WSElement>
            <WSText.Heading5>{name}</WSText.Heading5>
            <WSText.ParagraphXs color="gray500" mt="XS">
              {atAGlance}
            </WSText.ParagraphXs>
          </WSElement>
        </WSFlexBox.CenterY>

        <WSFlexBox.CenterY
          justify="space-between"
          wrap="nowrap"
          style={{ flexBasis: "25%" }}
        >
          <WSText.ParagraphSm>
            Cost: {getCostOfBenefitWithSubscription(benefit, subscription)}
          </WSText.ParagraphSm>
          {!isMobile && <WSIcon block name="chevron-right" color="blue500" />}
        </WSFlexBox.CenterY>
      </WSFlexBox>
    </WSPanel>
  );
};
